export default "__VITE_ASSET__GZoIUCiq__"